import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CourseCalendarDateDefault } from "@shared/models/course"
import type {
  RotationCalendarRotation,
  RotationCalendarSemester,
} from "@shared/models/rotation-calendar"
import findDocument from "cc-frontend/helpers/find-document"
import hasMany from "cc-frontend/helpers/has-many"
import { filter, find } from "lodash-es"

@tagName("")
export default class WeeklyOrderCourseSlotProvider extends Component {
  // args
  rotation!: RotationCalendarRotation
  semester!: RotationCalendarSemester

  @service("ember-store") store

  @findDocument("card.attributes.courseId", "course") course
  @hasMany("planbook", "card-stack", "cardStackTemplates") planbookLessonTemplates

  @computed("course.content.attributes.calendar.version", "rotation.id")
  get courseRotationTemplate() {
    if (this.course.isFulfilled !== true) return null
    if (this.course.content === undefined) return null
    return find(
      filter(this.course.content.attributes.calendar.dates, { type: "course-date-default" }),
      (date: CourseCalendarDateDefault) => {
        return (
          date.attributes.rotationId === this.rotation.id &&
          date.attributes.semesterId === this.semester.id
        )
      }
    )
  }

  @findDocument("courseRotationTemplate.attributes.cardStackId", "card-stack") lesson
}
